import { useState } from "react";
import { Plus, X, UserPlus, Calendar, ChevronRight } from "lucide-react";
import api from "../../services/api";

var PRODUCT_OPTIONS = [
  { value: "consorcio", label: "Consórcio" },
  { value: "seguro", label: "Seguro" },
  { value: "carta_contemplada", label: "Carta Contemplada" },
];

var SCHEDULE_TYPES = [
  { value: "call", label: "Ligação" },
  { value: "presencial", label: "Presencial" },
  { value: "video", label: "Vídeo-chamada" },
];

function QuickAddFAB() {
  var openState = useState(false);
  var isOpen = openState[0];
  var setIsOpen = openState[1];
  var modeState = useState(null);
  var mode = modeState[0];
  var setMode = modeState[1];
  var loadingState = useState(false);
  var loading = loadingState[0];
  var setLoading = loadingState[1];
  var msgState = useState(null);
  var msg = msgState[0];
  var setMsg = msgState[1];

  var leadState = useState({
    name: "", email: "", phone: "", product_type: "consorcio", value: "", description: "",
  });
  var lead = leadState[0];
  var setLead = leadState[1];

  var scheduleState = useState({
    client_name: "", client_email: "", schedule_type: "call", date: "", notes: "",
  });
  var schedule = scheduleState[0];
  var setSchedule = scheduleState[1];

  function resetAndClose() {
    setIsOpen(false);
    setMode(null);
    setMsg(null);
    setLead({ name: "", email: "", phone: "", product_type: "consorcio", value: "", description: "" });
    setSchedule({ client_name: "", client_email: "", schedule_type: "call", date: "", notes: "" });
  }

  function handleOpen() {
    setIsOpen(true);
    setMode(null);
    setMsg(null);
  }

  async function submitLead(e) {
    e.preventDefault();
    if (!lead.name.trim()) return;
    setLoading(true);
    setMsg(null);
    try {
      var payload = {
        name: lead.name.trim(),
        email: lead.email.trim() || null,
        phone: lead.phone.trim() || null,
        product_type: lead.product_type,
        value: lead.value ? parseFloat(lead.value) : null,
        description: lead.description.trim() || null,
      };
      await api.post("/leads", payload);
      setMsg({ type: "success", text: "Lead cadastrado com sucesso!" });
      setTimeout(function() { resetAndClose(); window.dispatchEvent(new Event("dashboard:refresh")); }, 1200);
    } catch (err) {
      var detail = err.response?.data?.detail || "Erro ao cadastrar lead";
      setMsg({ type: "error", text: typeof detail === "string" ? detail : "Erro ao cadastrar lead" });
    } finally {
      setLoading(false);
    }
  }

  async function submitSchedule(e) {
    e.preventDefault();
    if (!schedule.client_name.trim() || !schedule.date) return;
    setLoading(true);
    setMsg(null);
    try {
      var payload = {
        client_name: schedule.client_name.trim(),
        client_email: schedule.client_email.trim() || null,
        schedule_type: schedule.schedule_type,
        date: new Date(schedule.date).toISOString(),
        notes: schedule.notes.trim() || null,
      };
      await api.post("/schedule", payload);
      setMsg({ type: "success", text: "Reunião agendada com sucesso!" });
      setTimeout(function() { resetAndClose(); window.dispatchEvent(new Event("dashboard:refresh")); }, 1200);
    } catch (err) {
      var detail = err.response?.data?.detail || "Erro ao agendar reunião";
      setMsg({ type: "error", text: typeof detail === "string" ? detail : "Erro ao agendar reunião" });
    } finally {
      setLoading(false);
    }
  }

  function updateLead(field, value) {
    setLead(function(prev) { var n = {}; for (var k in prev) n[k] = prev[k]; n[field] = value; return n; });
  }

  function updateSchedule(field, value) {
    setSchedule(function(prev) { var n = {}; for (var k in prev) n[k] = prev[k]; n[field] = value; return n; });
  }

  if (!isOpen) {
    return (
      <button
        onClick={handleOpen}
        data-testid="fab-quick-add"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#F26A4B] hover:bg-[#e05a3b] text-white rounded-full shadow-lg shadow-[#F26A4B]/30 flex items-center justify-center transition-all hover:scale-110 active:scale-95"
      >
        <Plus className="w-6 h-6" />
      </button>
    );
  }

  return (
    <>
      <div className="fixed inset-0 bg-black/40 z-50" onClick={resetAndClose} />
      <div className="fixed bottom-0 left-0 right-0 sm:bottom-auto sm:top-1/2 sm:left-1/2 sm:-translate-x-1/2 sm:-translate-y-1/2 z-50 sm:max-w-md sm:w-full" data-testid="quick-add-modal">
        <div className="bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl max-h-[85vh] overflow-y-auto">
          <div className="flex items-center justify-between p-4 border-b border-gray-100">
            <h2 className="text-lg font-bold text-[#0A2F3D]">
              {mode === null ? "Cadastro Rápido" : mode === "lead" ? "Novo Lead" : "Agendar Reunião"}
            </h2>
            <button onClick={resetAndClose} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-testid="quick-add-close">
              <X className="w-5 h-5 text-gray-500" />
            </button>
          </div>

          {msg && (
            <div className={"mx-4 mt-3 px-4 py-2.5 rounded-lg text-sm font-medium " + (msg.type === "success" ? "bg-emerald-50 text-emerald-700 border border-emerald-200" : "bg-red-50 text-red-700 border border-red-200")} data-testid="quick-add-message">
              {msg.text}
            </div>
          )}

          {mode === null && (
            <div className="p-4 space-y-3">
              <button
                onClick={function() { setMode("lead"); }}
                data-testid="quick-add-lead-option"
                className="w-full flex items-center gap-4 p-4 rounded-xl border-2 border-gray-100 hover:border-[#F26A4B]/40 hover:bg-[#F26A4B]/5 transition-all group"
              >
                <div className="w-12 h-12 rounded-xl bg-[#F26A4B]/10 flex items-center justify-center flex-shrink-0 group-hover:bg-[#F26A4B]/20 transition-colors">
                  <UserPlus className="w-6 h-6 text-[#F26A4B]" />
                </div>
                <div className="flex-1 text-left">
                  <p className="font-semibold text-[#0A2F3D]">Novo Lead</p>
                  <p className="text-xs text-gray-500">Cadastrar cliente potencial</p>
                </div>
                <ChevronRight className="w-5 h-5 text-gray-300 group-hover:text-[#F26A4B] transition-colors" />
              </button>
              <button
                onClick={function() { setMode("schedule"); }}
                data-testid="quick-add-schedule-option"
                className="w-full flex items-center gap-4 p-4 rounded-xl border-2 border-gray-100 hover:border-[#3B82F6]/40 hover:bg-[#3B82F6]/5 transition-all group"
              >
                <div className="w-12 h-12 rounded-xl bg-[#3B82F6]/10 flex items-center justify-center flex-shrink-0 group-hover:bg-[#3B82F6]/20 transition-colors">
                  <Calendar className="w-6 h-6 text-[#3B82F6]" />
                </div>
                <div className="flex-1 text-left">
                  <p className="font-semibold text-[#0A2F3D]">Agendar Reunião</p>
                  <p className="text-xs text-gray-500">Marcar visita ou ligação</p>
                </div>
                <ChevronRight className="w-5 h-5 text-gray-300 group-hover:text-[#3B82F6] transition-colors" />
              </button>
            </div>
          )}

          {mode === "lead" && (
            <form onSubmit={submitLead} className="p-4 space-y-3">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Nome *</label>
                <input
                  type="text" value={lead.name} onChange={function(e) { updateLead("name", e.target.value); }}
                  className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#F26A4B]/30 focus:border-[#F26A4B]"
                  placeholder="Nome do cliente" required data-testid="quick-lead-name"
                />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Email</label>
                  <input
                    type="email" value={lead.email} onChange={function(e) { updateLead("email", e.target.value); }}
                    className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#F26A4B]/30 focus:border-[#F26A4B]"
                    placeholder="email@exemplo.com" data-testid="quick-lead-email"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Telefone</label>
                  <input
                    type="tel" value={lead.phone} onChange={function(e) { updateLead("phone", e.target.value); }}
                    className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#F26A4B]/30 focus:border-[#F26A4B]"
                    placeholder="(11) 99999-9999" data-testid="quick-lead-phone"
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Produto</label>
                  <select
                    value={lead.product_type} onChange={function(e) { updateLead("product_type", e.target.value); }}
                    className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#F26A4B]/30 focus:border-[#F26A4B] bg-white"
                    data-testid="quick-lead-product"
                  >
                    {PRODUCT_OPTIONS.map(function(o) { return <option key={o.value} value={o.value}>{o.label}</option>; })}
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Valor (R$)</label>
                  <input
                    type="number" value={lead.value} onChange={function(e) { updateLead("value", e.target.value); }}
                    className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#F26A4B]/30 focus:border-[#F26A4B]"
                    placeholder="0,00" step="0.01" data-testid="quick-lead-value"
                  />
                </div>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Observação</label>
                <textarea
                  value={lead.description} onChange={function(e) { updateLead("description", e.target.value); }}
                  className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#F26A4B]/30 focus:border-[#F26A4B] resize-none"
                  rows="2" placeholder="Detalhes sobre o lead..." data-testid="quick-lead-description"
                />
              </div>
              <div className="flex gap-2 pt-1">
                <button type="button" onClick={function() { setMode(null); setMsg(null); }}
                  className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors">
                  Voltar
                </button>
                <button type="submit" disabled={loading}
                  className="flex-1 px-4 py-2.5 bg-[#F26A4B] text-white rounded-xl text-sm font-medium hover:bg-[#e05a3b] transition-colors disabled:opacity-50"
                  data-testid="quick-lead-submit">
                  {loading ? "Salvando..." : "Cadastrar Lead"}
                </button>
              </div>
            </form>
          )}

          {mode === "schedule" && (
            <form onSubmit={submitSchedule} className="p-4 space-y-3">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Nome do Cliente *</label>
                <input
                  type="text" value={schedule.client_name} onChange={function(e) { updateSchedule("client_name", e.target.value); }}
                  className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
                  placeholder="Nome do cliente" required data-testid="quick-schedule-name"
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Email do Cliente</label>
                <input
                  type="email" value={schedule.client_email} onChange={function(e) { updateSchedule("client_email", e.target.value); }}
                  className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
                  placeholder="email@exemplo.com" data-testid="quick-schedule-email"
                />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Tipo</label>
                  <select
                    value={schedule.schedule_type} onChange={function(e) { updateSchedule("schedule_type", e.target.value); }}
                    className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6] bg-white"
                    data-testid="quick-schedule-type"
                  >
                    {SCHEDULE_TYPES.map(function(o) { return <option key={o.value} value={o.value}>{o.label}</option>; })}
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Data/Hora *</label>
                  <input
                    type="datetime-local" value={schedule.date} onChange={function(e) { updateSchedule("date", e.target.value); }}
                    className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6]"
                    required data-testid="quick-schedule-date"
                  />
                </div>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Observação</label>
                <textarea
                  value={schedule.notes} onChange={function(e) { updateSchedule("notes", e.target.value); }}
                  className="w-full px-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 focus:border-[#3B82F6] resize-none"
                  rows="2" placeholder="Detalhes da reunião..." data-testid="quick-schedule-notes"
                />
              </div>
              <div className="flex gap-2 pt-1">
                <button type="button" onClick={function() { setMode(null); setMsg(null); }}
                  className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors">
                  Voltar
                </button>
                <button type="submit" disabled={loading}
                  className="flex-1 px-4 py-2.5 bg-[#3B82F6] text-white rounded-xl text-sm font-medium hover:bg-[#2563EB] transition-colors disabled:opacity-50"
                  data-testid="quick-schedule-submit">
                  {loading ? "Agendando..." : "Agendar Reunião"}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
}

export default QuickAddFAB;
